import { Model } from '../base/Modal';
import { AppStateComponents, SETTINGS } from '../../utils/constants';
// Класс товара
export class Product extends Model {
}
// Класс управления приложением  implements IAppState
export class AppState extends Model {
    constructor(api, data, events) {
        super(data, events);
        this.api = api;
        this.products = new Map();
        this.basket = new Map();
        this.basketTotal = 0;
        this.order = {
            payment: null,
            address: '',
            email: '',
            phone: '',
            total: 0,
            items: [],
        };
        this.formError = {};
    }
    // api
    async laodProducts() {
        this.products.clear();
        const products = await this.api.getProducts();
        for (const product of products)
            this.products.set(product.id, product);
        this.emitChanges(AppStateComponents.PRODUCT.CHANGE);
        return this.api.getProducts();
    }
    async orderProducts() {
        try {
            const result = await this.api.orderProducts(this.order);
            this.clearBasket();
            this.refreshOrder();
            this.resetSelected();
            return result;
        }
        catch (err) {
            console.log(err);
        }
    }
    // basket
    addProductInBasket(product) {
        if (!product)
            throw new Error("[INVALID PRODUCT]" /* EnumErrorAppStateComponents.InvProduct */);
        if (this.products.has(product.id))
            this.basket.set(product.id, product);
        else
            throw new Error("[INVALIDE PRODUCT ID]" /* EnumErrorAppStateComponents.InvProductId */);
    }
    getAmountProductInBasket() {
        return this.basket.size;
    }
    getTotalPricteInBasket() {
        return this.basketTotal;
    }
    deleteProductInBasket(id) {
        this.basket.delete(id);
    }
    setOrderItems() {
        this.order.items = Array.from(this.basket.values()).map((product) => product.id);
    }
    setOrderField(field, value) {
        this.order[field] = value;
        this.order.total = this.basketTotal;
        if (this.validateContacts())
            this.events.emit(AppStateComponents.CONTACT.READY, this.order);
        if (this.validateOrder())
            this.events.emit(AppStateComponents.ORDER.READY, this.order);
    }
    validateOrder() {
        const err = {};
        if (!this.order.address)
            err.address = SETTINGS.errorFormText.address;
        if (!this.order.payment)
            err.payment = SETTINGS.errorFormText.payment;
        this.formError = err;
        this.events.emit(AppStateComponents.ORDER.ERROR, this.formError);
        return Object.keys(err).length === 0;
    }
    validateContacts() {
        const err = {};
        if (!this.order.email)
            err.email = SETTINGS.errorFormText.email;
        if (!this.order.phone)
            err.phone = SETTINGS.errorFormText.phone;
        this.formError = err;
        this.events.emit(AppStateComponents.CONTACT.ERROR, this.formError);
        return Object.keys(err).length === 0;
    }
    clearBasket() {
        this.basket.clear();
        this.basketTotal = 0;
    }
    refreshOrder() {
        this.order = {
            payment: null,
            address: '',
            email: '',
            phone: '',
            total: 0,
            items: [],
        };
    }
    resetSelected() {
        Array.from(this.products.values()).forEach((item) => (item.selected = false));
    }
}
